import { createFileRoute } from '@tanstack/react-router';

import { PresentationBrowse } from '@/module/Author/Presentation';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PresentationBrowse />;
}
